export function urlToRelative(urlString) {
    if (!urlString) {
        return undefined;
    }
    // return only the part after the domain, e.g. path and search, but not protocol and host
    const url = new URL(urlString);
    return url.pathname + url.search;
}
